<dashboardnav>
  <cradua-pipeline-license-stakeholder [pipelinelicensestakeholders]="pipelinelicensestakeholders$ | async" (pipelinelicensestakeholder)="onSubmitPipelineLicenseStakeholder($event)" (deletePipelineLicenseStakeholderEvent)="onDeletePipelineLicenseStakeholder($event)"
    *ngIf="(isLoadingPipelineLicenseStakeholder$ | async ) === false">
  </cradua-pipeline-license-stakeholder>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingPipelineLicenseStakeholder$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
